module.exports = __webpack_public_path__ + "img/heart_bj.cb896c7b.png";